module.exports = __webpack_public_path__ + "img/MISAWA-300.97297718.png";